/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 public/meshes/Liner_3v0.glb -o src/meshes/Liner_3v0.tsx -r public -t -k -s -p 7 
Modified by: Aeroplane GLTFJSX Generator v1.9.1
*/

import { Group, AnimationAction, SkinnedMesh, Bone, MeshStandardMaterial, AnimationClip } from "three";
import { forwardRef, ForwardedRef, useEffect, useImperativeHandle, ForwardRefExoticComponent, useRef } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";
import useM_CorrugatedCardboardEdge_Liner from "@materials/M_CorrugatedCardboardEdge_Liner";
import useM_CorrugatedCardboard_Liner from "@materials/M_CorrugatedCardboard_Liner";
import { GLTFJSXUtils } from "@utils/GLTFJSXUtils";
import { GLTF } from "three-stdlib";
import { ObjectUtils } from "@utils/ObjectUtils";
import { assetPath } from "@utils/Config";

const mesh = assetPath("/meshes/Liner_3v0.glb");

type GLTFResult = GLTF & {
    nodes: {
        ThermalLiner_1: SkinnedMesh;
        ThermalLiner_2: SkinnedMesh;
        b_Main: Bone;
        neutral_bone: Bone;
    }
    materials: {
        M_CorrugatedCardboard_Liner: MeshStandardMaterial;
        M_CorrugatedCardboardEdge_Liner: MeshStandardMaterial;
    }
    animations: GLTFAction[]
}

type ActionName = "ThermalLinerRigAction"
interface GLTFAction extends AnimationClip {
    name: ActionName
}
export type Handle = {
    root: Group | null;
    meshes: GLTFResult["nodes"];
    actions: Record<ActionName, AnimationAction | null>;
};
export function useHandle(ref: ForwardedRef<Group>) {
    const handle = useRef<Handle>(null);
    useEffect(() => {
        if (!ref) return;
        if (typeof ref === "function") ref(handle.current?.root ?? null);
        else ref.current = handle.current?.root ?? null;
    }, [handle, ref]);
    return handle;
};
export default forwardRef<Handle, JSX.IntrinsicElements["group"]>(function Model(props, ref) {
    const group = useRef<Group>(null);
    const { nodes, materials, animations } = useGLTF(mesh) as GLTFResult;
    const { actions } = useAnimations(animations, group);
    const M_CorrugatedCardboardEdge_Liner = useM_CorrugatedCardboardEdge_Liner();
    const M_CorrugatedCardboard_Liner = useM_CorrugatedCardboard_Liner();
    useImperativeHandle(ref, () => GLTFJSXUtils.createHandle<Handle>({ root: group.current, actions }, nodes), [group, nodes, actions]);
    return (
        <group ref={group} {...props} dispose={null}>
            <group name="Scene">
                <group name="ThermalLinerRig">
                    <primitive object={nodes.b_Main} />
                    <primitive object={nodes.neutral_bone} />
                    <group name="ThermalLiner">
                        <skinnedMesh name="ThermalLiner_1" receiveShadow={props.receiveShadow} castShadow={props.castShadow} {...ObjectUtils.pick(nodes.ThermalLiner_1, "geometry", "morphTargetDictionary", "morphTargetInfluences")} material={M_CorrugatedCardboard_Liner} skeleton={nodes.ThermalLiner_1.skeleton} raycast={props.raycast} renderOrder={props.renderOrder} />
                        <skinnedMesh name="ThermalLiner_2" receiveShadow={props.receiveShadow} castShadow={props.castShadow} {...ObjectUtils.pick(nodes.ThermalLiner_2, "geometry", "morphTargetDictionary", "morphTargetInfluences")} material={M_CorrugatedCardboardEdge_Liner} skeleton={nodes.ThermalLiner_2.skeleton} raycast={props.raycast} renderOrder={props.renderOrder} />
                    </group>
                </group>
            </group>
        </group>
    );
});

useGLTF.preload(mesh, true, true);
